module.exports = __webpack_public_path__ + "img/bigfive_c1.8174d2dc.png";